/**
 * Pull in and setup JS Packages.
 */
require('./bootstrap');

import Vue from 'vue'

//Token expire component
Vue.component('token-expire', require('./vues/public/token_expire.vue').default);

Vue.component('cookies-notice', require('./vues/public/cookies-notice.vue').default);

/**
 * Start main Vue public app.
 * @type {Vue}
 */
window.onload = function () {
    const app = new Vue({
    	el: '#publicApp',
    });
};

require('./public/custom');
